import { createContext } from 'react'

const NewspaperConfigContext = createContext()

export default NewspaperConfigContext
